import {useMemo} from "react";
import ApiServiceV2 from "../services/ApiServiceV2";
import {routes} from "./routes";

export const useDeleteData = (url: keyof typeof routes, id: number|string) => {
    const api = useMemo(() => {
        return new ApiServiceV2()
    }, [])

    //api call
    const submit = async () => {
        return api.callApi(routes[url] + '/' + id, 'delete')
    }

    return {
        submit
    }
}
